import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fechamento-viagem`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        update(id, params) {
            return repository.put(`${baseUrl}/${id}`, params)
        },
        veiculos(queryParms = {}) {
            return repository.get(`${baseUrl}/veiculo?${urlUtil.serialize(queryParms)}`)
        },
        motoristas(queryParms = {}) {
            return repository.get(`${baseUrl}/motorista?${urlUtil.serialize(queryParms)}`)
        },
        horarios(queryParms = {}) {
            return repository.get(`${baseUrl}/horario?${urlUtil.serialize(queryParms)}`)
        },
        search(queryParms = {}) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(queryParms)}`)
        },
    }
}